<template>
	<div id="shippingRequestComponent002">
		<div v-show="true">
			<button ref="btnClearShippingRequest" @click="clearShippingRequestLocal">Clear
				ShippingRequestComponent
			</button>
			<button ref="btnShowShippingRequest" @click="showShippingRequestLocal">Show
				ShippingRequestComponent
			</button>
		</div>
		<div class="card">
			<div class="card-header d-flex flex-between-center bg-light py-2" v-show="!gettingShippingRequest">
				<h6 class="mb-0 py-2">
					Solicitud de Envío
					<span v-if="objectShippingRequest.id == 0">Nueva</span>
					<span v-else>- {{ objectShippingRequest.id }}</span>

				</h6>
				<div class="dropdown font-sans-serif btn-reveal-trigger">
					<select class="form-select form-select-sm" aria-label=".form-select-sm example"
						v-model="trackingsShippingIDSelected" @change="changeStatusSelectLocal"
						:disabled="disabledSelectedTrackingsShipping" v-show="objectShippingRequest.id != 0">
						<option v-for="(tsr, i) in listTrackingsShippingRequestFilter" :key="i" :value="tsr.id"
							v-if="tsr.status_id != null" :disabled="objectShippingRequest.status_id == tsr.status_id">
							{{ tsr.status.name }}
						</option>
					</select>
				</div>
			</div>
			<div class="card-body">
				<div class="d-grid">
					<div class="border-start border-3 border-muted px-3 py-2"
						v-if="linkGenesys && objectShippingRequest.id == 0">
						<div class="text-center mt-1">Vinculación con Genesys</div>
						<div class="row g-2">
							<div class="col-7">
								<div class="mb-1">
									<label class="form-label" for="tipocompSelect">Comprobante:</label>
									<select class="form-select form-select-sm" aria-label=".form-select-sm example"
										v-model="tipocompcodSearch" @change="changeTipocompSelectLocal"
										:disabled="disabledAll">
										<option value="0" selected>Sin vinculación</option>
										<option :value="tc.tipocompcod" v-for="(tc, i) in listTipocompFilter" :key="i">
											{{
												tc.tipocompdesc }}</option>
									</select>
								</div>
							</div>
							<div class="col-5">
								<div class="mb-1">
									<label class="form-label" for="nrocompInput">Número:</label>
									<div class="input-group">
										<input class="form-control form-control-sm shadow-none search" type="search"
											placeholder="Número" aria-label="search" ref="nrocompInput"
											v-model="nrocompSearch" @keyup.enter="getMovimientoLocal()"
											@change="changeNrocompInputLocal"
											:disabled="!(tipocompcodSearch > 0) || disabledAll">
										<div class="input-group-text bg-transparent pointer"
											@click="getMovimientoLocal()">
											<span class="fa fa-search fs--1 text-600"></span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="mb-1">
							<small id="emailHelp" class="fs--2 form-text text-muted">
								<div v-if="searchingMovimiento">
									<small>
										<small class="spinner-border spinner-border-sm" role="status">
											<span class="visually-hidden">Loading...</span>
										</small>
									</small>
									<i>Buscando el comprobante en genesys ...</i>
								</div>
								<div v-else>
									<span v-if="objectCabmov.nrocomp > 0">{{ objectCabmov.fecmov }} - {{
										objectCabmov.succod }}
										| {{ objectCabmov.codbareti }}</span>
								</div>
							</small>
						</div>
					</div>
					<hr />
					<div class="border-start border-3 border-primary px-3 py-2">
						<div class="text-center mt-1">Datos Destinatario</div>
						<div class="row g-2">
							<div class="col-6">
								<div class="mb-1">
									<label class="form-label" for="sendToInput">Nombre:</label>
									<input class="form-control form-control-sm" ref="sendToInput" type="text"
										placeholder="Juanito" v-model="objectShippingRequest.recipient_data.name"
										:disabled="disabledAll" />
								</div>
							</div>
							<div class="col-3">
								<div class="mb-1">
									<label class="form-label" for="documentNumberInput">Apellido Paterno:</label>
									<input class="form-control form-control-sm" type="text" placeholder="Perez"
										v-model="objectShippingRequest.recipient_data.last_name"
										:disabled="disabledAll" />
								</div>
							</div>
							<div class="col-3">
								<div class="mb-1">
									<label class="form-label" for="phoneInput">Apellido Materno:</label>
									<input class="form-control form-control-sm" type="text" placeholder="Gonzalez"
										v-model="objectShippingRequest.recipient_data.second_last_name"
										:disabled="disabledAll" />
								</div>
							</div>
						</div>
						<div class="row g-2">
							<div class="col-4">
								<div class="mb-1">
									<label class="form-label" for="sendToInput">RUT:</label>
									<input class="form-control form-control-sm" ref="sendToInput" type="text"
										placeholder="12345678-9"
										v-model="objectShippingRequest.recipient_data.number_document"
										:disabled="disabledAll" />
								</div>
							</div>
							<div class="col-4">
								<div class="mb-1">
									<label class="form-label" for="documentNumberInput">Telefono:</label>
									<input class="form-control form-control-sm" type="text" placeholder="56987654321"
										v-model="objectShippingRequest.recipient_data.phone" :disabled="disabledAll" />
								</div>
							</div>
							<div class="col-4">
								<div class="mb-1">
									<label class="form-label" for="phoneInput">Email:</label>
									<input class="form-control form-control-sm" type="text"
										placeholder="juanperez@email.com"
										v-model="objectShippingRequest.recipient_data.email" :disabled="disabledAll" />
								</div>
							</div>
						</div>
					</div>
					<hr />
					<div class="border-start border-3 border-info px-3 py-2">
						<div class="text-center mt-1">Transporte y Dirección</div>
						<div class="row g-2">
							<div class="col-3">
								<div class="mb-1">
									<label class="form-label" for="sendToInput">Transpote:</label>
									<select class="form-select form-select-sm" aria-label=".form-select-sm example"
										v-model="objectShippingRequest.recipient_data.transport_id"
										:disabled="disabledAll" @change="changeTransportSelectLocal">
										<option value="0" disabled selected>Seleccione el transporte</option>
										<option v-for="(t, index) in listTransportsFilter" :key="index" :value="t.id">
											{{ t.name }}
										</option>
									</select>
								</div>
							</div>
							<div class="col-3">
								<div class="mb-1">
									<label class="form-label" for="sendToInput">Tipo de Entrega:</label>
									<select class="form-select form-select-sm" aria-label=".form-select-sm example"
										v-model="objectShippingRequest.recipient_data.delivery_type"
										:disabled="disabledAll || listDeliberyTypes.length == 0">
										<option value="-1" disabled selected>Seleccione el transporte</option>
										<option v-for="(d, index) in listDeliberyTypes" :key="index" :value="d.id">
											{{ d.name }}
										</option>
									</select>
								</div>
							</div>
							<div class="col-3">
								<div class="mb-1">
									<label class="form-label" for="sendToInput">Tipo de Servicio:</label>
									<select class="form-select form-select-sm" aria-label=".form-select-sm example"
										v-model="objectShippingRequest.recipient_data.service_type"
										:disabled="disabledAll || listServicesTypes.length == 0">
										<option value="-1" disabled selected>Seleccione el transporte</option>
										<option v-for="(s, index) in listServicesTypes" :key="index" :value="s.id">
											{{ s.name }}
										</option>
									</select>
								</div>
							</div>
							<div class="col-3 text-end">
								<div class="form-check form-switch text-end">
									<label class="form-check-label float-end" for="flexSwitchCheckDefault">
										Por pagar
									</label>
									<input class="form-check-input float-end me-1" type="checkbox"
										v-model="objectShippingRequest.recipient_data.paid_shipping"
										:disabled="disabledAll || disabledInputPaidShipping" />
								</div>
							</div>
						</div>
						<div class="row g-2">
							<div class="col-3">
								<div class="mb-1">
									<label class="form-label" for="comunaSelect">
										Comuna:
										<i class="text-warning" v-if="objectShippingRequest.id > 0">
											<small
												v-if="objectShippingRequest.recipient_data.comuna != null && objectShippingRequest.recipient_data.comuna_id == null">
												iSystem4: {{ objectShippingRequest.recipient_data.comuna.name }}
											</small>
										</i>
									</label>
									<select class="form-select form-select-sm" aria-label=".form-select-sm example"
										v-model="objectShippingRequest.recipient_data.comuna_id"
										@change="changeComunaSelectLocal" :disabled="disabledAll">
										<option value="0" disabled selected>Seleccione la Comuna</option>
										<option v-for="(c, i) in listComunasFilter" :key="i" :value="c.id">{{ c.name }}
											- {{
												c.region_synthetic }}</option>
									</select>
								</div>
							</div>
							<div class="col-4" v-show="selectAgencia == false">
								<div class="mb-1">
									<label class="form-label" for="sendToInput">Calle:</label>
									<input class="form-control form-control-sm" ref="streetInput" type="text"
										placeholder="Santa Elena" v-model="objectShippingRequest.recipient_data.street"
										:disabled="disabledAll" />
								</div>
							</div>
							<div class="col-2" v-show="selectAgencia == false">
								<div class="mb-1">
									<label class="form-label" for="sendToInput">Numero:</label>
									<input class="form-control form-control-sm" ref="streetNumberInput" type="text"
										placeholder="1038" v-model="objectShippingRequest.recipient_data.street_number"
										:disabled="disabledAll" />
								</div>
							</div>
							<div class="col-3" v-show="selectAgencia == false">
								<div class="mb-1">
									<label class="form-label" for="sendToInput">Dpto/Casa/etc:</label>
									<input class="form-control form-control-sm" ref="addressLine2Input" type="text"
										placeholder="Dpto 4"
										v-model="objectShippingRequest.recipient_data.address_line_2"
										:disabled="disabledAll" />
								</div>
							</div>
							<div class="col-4" v-show="selectAgencia == true">
								<div class="mb-1">
									<label class="form-label" for="comunaSelect">
										Agencia:
									</label>
									<select class="form-select form-select-sm" aria-label=".form-select-sm example"
										@change="changeAgenciaSelectLocal" :disabled="disabledAll">
										<option value="0" disabled selected>Seleccione la Agencia</option>
										<option v-for="(a, i) in listAgenciasFilter" :key="i" :value="a.id">{{ a.name }}
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card-footer bg-light py-2">
				<div class="row flex-between-center g-0">
					<div class="col-auto">
						<button class="btn btn-sm btn-danger">
							Eliminar
						</button>
					</div>
					<div class="col-auto">
						<button class="btn btn-sm btn-primary">
							Guardar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import axiosAction from '@/mixins/axiosAction.js'
import errors from '@/mixins/errors.js'
import shippingsRequest from '@/mixins/shippingsRequest'
import trackingShippingRequest from '@/mixins/shippingsRequest/trackingShippingRequest.js'
import transport from '@/mixins/generals/transport.js'
import movimiento from '@/mixins/genesys/movimiento.js'
import domicilio from '@/mixins/genesys/domicilio.js'
import genesys from '@/mixins/genesys'
import comuna from '@/mixins/generals/comuna.js'
import starken from '@/mixins/generals/starken.js'
import correosChile from '@/mixins/generals/correosChile.js'

import MessageLoadingComponent from '@/components/MessageLoadingComponent.vue'

export default {
	name: 'Nombre',
	mixins: [
		mixin,
		axiosAction,
		errors,
		shippingsRequest,
		trackingShippingRequest,
		transport,
		movimiento,
		domicilio,
		genesys,
		comuna,
		correosChile,
		starken
	],
	props: ['id', 'withLinkGenesys'],
	data() {
		return {
			fromShow: 'internal',
			clicodsNotConsider: [0, 1, 5006121],
			trackingsShippingIDSelected: -1,
		}
	},
	components: {
		'mensagge-loading-component': MessageLoadingComponent
	},
	computed: {
		comunaSelected() {
			let comuna = null
			if (this.objectShippingRequest.recipient_data.comuna_id > 0) {
				let i = this.listComunasFilter.map(c => parseInt(c.id)).indexOf(parseInt(this.objectShippingRequest.recipient_data.comuna_id))
				if (i > -1) {
					comuna = this.listComunasFilter[i]
				}
			}
			return comuna
		},
		deliverySelected() {
			let delivery = null
			if (this.transportSelected != null) {
				if (this.transportSelected.hasOwnProperty('config')) {
					let i = this.transportSelected.config.options.deliveryTypes.list.map(e => parseInt(e.id)).indexOf(parseInt(this.objectShippingRequest.recipient_data.delivery_type))
					if (i > -1) {
						delivery = this.transportSelected.config.options.deliveryTypes.list[i]
					}
				}
			}
			return delivery
		},
		disabledAll() {
			if (this.searchingMovimiento) {
				return true
			}
			if (this.searchingDomicilio) {
				return true
			}
			if (this.savedShippingRequest) {
				return true
			}
			let i = this.listStatusEditable.map(s => parseInt(s)).indexOf(parseInt(this.objectShippingRequest.status_id))
			if (i == -1 && this.objectShippingRequest.status_id != null) {
				return true
			} else if (i > -1) {
				if (this.objectShippingRequest.user_id != this.getUser.id && !this.actionSecurity(17)) {
					return true
				}
			}
			return false
		},
		disabledSelectedTrackingsShipping() {
			if (this.disabledAll) {
				if (!this.searchingMovimiento && !this.searchingDomicilio && !this.savedShippingRequest) {
					if (this.actionSecurity(16)) {
						return false
					}
				}
			}
			return this.disabledAll
		},
		disabledInputPaidShipping() {
			if (this.deliverySelected != null) {
				if (this.deliverySelected.paid_shipping == false) {
					this.objectShippingRequest.recipient_data.paid_shipping = 0
					return true
				}
			}
			return false
		},
		listAgenciasFilter() {
			let list = []
			if (this.transportSelected != null) {
				if (this.comunaSelected != null) {
					if (this.selectAgencia == true) {
						if (this.transportSelected.hasOwnProperty('config')) {
							list = this[this.transportSelected.config.listAgencias]
						}
					}
				}
			}
			return list.filter(a => {
				if (this.comunaSelected != null) {
					if (this.comunaSelected.codigoComuna != undefined) {
						return a.comuna.code_dls == this.comunaSelected.codigoComuna
					} else if (this.comunaSelected.IdComuna != undefined) {
						return a.IdComuna == this.comunaSelected.IdComuna
					}
				}
				return true
			})
		},
		listComunasFilter() {
			let list = this.listComunas
			if (this.transportSelected != null) {
				if (this.transportSelected.hasOwnProperty('config')) {
					if (this.transportSelected.config.hasOwnProperty('listComunas')) {
						list = this[this.transportSelected.config.listComunas]
					}
				}
			}
			return list
		},
		listDeliberyTypes() {
			let list = []
			if (this.transportSelected != null) {
				if (this.transportSelected.hasOwnProperty('config')) {
					list = this.transportSelected.config.options.deliveryTypes.list
					this.objectShippingRequest.recipient_data.delivery_type = this.transportSelected.config.options.deliveryTypes.default
				}
			}
			return list
		},
		listServicesTypes() {
			let list = []
			if (this.transportSelected != null) {
				if (this.transportSelected.hasOwnProperty('config')) {
					list = this.transportSelected.config.options.serviceTypes.list.filter(l => {
						return l.list_delivery_types.map(e => parseInt(e)).indexOf(parseInt(this.objectShippingRequest.recipient_data.delivery_type)) > -1
					})
					this.objectShippingRequest.recipient_data.service_type = this.transportSelected.config.options.serviceTypes.default
				}
			}
			return list
		},
		listTipocompFilter() {
			return this.listTipocomp.filter(tc => {
				return tc.view
			})
		},
		listTrackingsShippingRequestFilter() {
			return this.listTrackingsShippingRequest
		},
		linkGenesys() {
			if (!this.needGenesys) {
				return false
			}
			if (!this.withLinkGenesys || this.withLinkGenesys == undefined) {
				return false

			}
			return true
		},
		selectAgencia() {
			if (this.deliverySelected != null) {
				return this.deliverySelected.require_branch
			}
			return false
		},
		transportSelected() {
			let transport = null
			this.objectShippingRequest.recipient_data.paid_shipping = 0
			this.objectShippingRequest.recipient_data.office = 0
			this.objectShippingRequest.recipient_data.service_type = 0
			this.objectShippingRequest.recipient_data.delivery_type = 0
			if (this.objectShippingRequest.recipient_data.transport_id > 0) {
				let i = this.listTransportsFilter.map(t => parseInt(t.id)).indexOf(parseInt(this.objectShippingRequest.recipient_data.transport_id))
				if (i > -1) {
					transport = this.listTransportsFilter[i]
				}
			}
			return transport
		},
	},
	methods: {
		analyzeResultConsultarBoletaLocal(cabmov) {
			if (cabmov.tipocompcodLegal > 0 && cabmov.nrocompLegal != '') {
				this.typeLegalDocumentId = cabmov.tipocompcodLegal
				this.legalDocumentNumber = cabmov.nrocompLegal
			}
		},
		analyzeResultConsultarClienteEnvioLocal(climov) {
			if (climov.length == 1) {
				let index = this.clicodsNotConsider.map(c => c).indexOf(parseInt(climov[0].clicod))
				if (index == -1) {
					this.objectShippingRequest.recipient_data.sendto = climov[0].cargadoa
					this.getDomicilioWithCliente(climov[0].domicod)
				} else {
					setTimeout(() => { this.$refs.sendToInput.focus() }, 50)
				}
			}
		},
		analyzeResultConsultarCobroLocal(brutocomp) {
			if (this.fromShow == 'internal') {
				this.objectShippingRequest.recipient_data.paid_shipping = 1
				this.objectShippingRequest.total_price = parseInt(brutocomp)
			}
		},
		analyzeResultGetMovimientoLocal(response) { },
		axiosResultLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'getAllTrackingsShippingRequestResult': this.getAllTrackingsShippingRequestResult(response); break;
				case 'getAllComunasResult': this.getAllComunasResult(response); break;
				case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
				case 'getStarkenCiudadesResult': this.getStarkenCiudadesResult(response); break;
				case 'getStarkenAgenciasResult': this.getStarkenAgenciasResult(response); break;
				case 'getDomicilioWithClienteResult': this.getDomicilioWithClienteResult(response); break;
				case 'getMovimientoResult': this.getMovimientoResult(response); break;
				case 'obtenerCorreosChileComunasResult': this.obtenerCorreosChileComunasResult(response); break;
				case 'obtenerCorreosChileSucursalesResult': this.obtenerCorreosChileSucursalesResult(response); break;
				case 'showShippingRequestResult': this.showShippingRequestResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')', this.$options.name); break;
			}
		},
		changeAgenciaSelectLocal() {
			console.log('Setear datos de agencia')
		},
		changeComunaSelectLocal() {
			//this.validateAddress()
			this.objectShippingRequest.recipient_data.comuna = this.comunaSelected
		},
		changeNrocompInputLocal() {
			if (this.fromShow == 'internal') {
				this.clearObjectShippingRequest()
				this.clearObjectCabmov()
			}
		},
		changeStatusSelectLocal() {
			this.addShippingRequestTrackingsShippingRequest(this.objectShippingRequest.id, this.trackingsShippingIDSelected)
		},
		changeTipocompSelectLocal() {
			if (this.fromShow == 'internal') {
				this.clearObjectShippingRequest()
				this.clearObjectCabmovLocal()
			}
		},
		changeTransportSelectLocal() {
			this.objectShippingRequest.recipient_data.transport = this.transportSelected
			if (this.fromShow == 'internal') {
				if (this.transportSelected.address != '' && this.transportSelected.address != null) {
					this.objectShippingRequest.recipient_data.address = this.transportSelected.address
				} else {
					this.objectShippingRequest.recipient_data.address = ''
				}
				if (this.transportSelected.comuna_id != null) {
					this.objectShippingRequest.recipient_data.comuna_id = this.transportSelected.comuna_id
					this.objectShippingRequest.recipient_data.comuna = this.comunaSelected
				} else {
					this.objectShippingRequest.recipient_data.comuna_id = 0
				}
			}
		},
		clearObjectCabmovLocal() {
			this.nrocompSearch = ''
			this.clearObjectCabmov()
			if (this.tipocompcodSearch > 0) {
				setTimeout(() => { this.$refs.nrocompInput.focus() }, 50)
			}
		},
		clearShippingRequestLocal() {
			this.trackingsShippingIDSelected = 0
			this.tipocompcodSearch = 0
			/*this.typeLegalDocumentId = 0
			this.legalDocumentNumber = ''
			this.idLocal = ''
			this.validatedAddress = false
			this.validatingAddress = false*/
			this.clearObjectShippingRequest()
			this.clearObjectCabmovLocal()
			setTimeout(() => { this.$refs.sendToInput.focus() }, 400)
		},
		determineStatusTracking(statusId) {
			let i = this.listTrackingsShippingRequest.map(ts => parseInt(ts.status_id)).indexOf(parseInt(statusId))
			return (i > -1) ? this.listTrackingsShippingRequest[i].id : -1
		},
		getAllTrackingsShippingRequestResultLocal(response) { },
		getAllTransportsResultLocal(response) { },
		getAllComunasResultLocal(response) {
			this.getStarkenCiudades()
			this.obtenerCorreosChileComunas()
		},
		getDomicilioWithClienteResultLocal(response) {
			if (response.data.data.length > 0) {
				this.objectShippingRequest.recipient_data.number_document = (response.data.data[0].clicuit == null) ? '' : response.data.data[0].clicuit
				this.objectShippingRequest.recipient_data.phone = (response.data.data[0].domitel == null) ? '' : response.data.data[0].domitel
				this.objectShippingRequest.recipient_data.email = (response.data.data[0].domimail == null) ? '' : response.data.data[0].domimail
				this.objectShippingRequest.recipient_data.address = (response.data.data[0].domicalle == null) ? '' : response.data.data[0].domicalle + ' ' + response.data.data[0].dominro
				let comuna = this.selectComunaByStr(response.data.data[0].dptodesc)
				this.objectShippingRequest.recipient_data.comuna_id = comuna.id
				this.objectShippingRequest.recipient_data.comuna = comuna
				let transport = this.selectTransporByStr(response.data.data[0].trandesc)
				this.objectShippingRequest.recipient_data.transport_id = transport.id
				this.objectShippingRequest.recipient_data.transport = transport
			}
		},
		getMovimientoLocal() {
			if (!isNaN(this.nrocompSearch) && this.nrocompSearch > 0) {
				if (this.fromShow == 'internal') {
					this.clearObjectCabmov()
					this.clearObjectShippingRequest()
				}
				this.nrocompSearch = this.nrocompSearch.trim()
				this.getMovimiento(this.tipocompcodSearch, this.nrocompSearch.trim())
			} else {
				this.showMsgErrorHandling('Sin Dato', 'Tienes que ingresar el numero de comprobante a buscar', 'warn', 5000, 'top right')
			}
		},
		getMovimientoResultLocal(response) {
			if (response.data.data.cabmov.nrocomp === this.nrocompSearch) {
				this.analyzeResultGetMovimiento(response, this.data != undefined)
			} else {
				this.showMsgErrorHandling('No Encontrado', 'El comprobante ' + this.nrocompSearch + ' no se ha encontrado en genesys', 'warn', 5000, 'top right')
			}
		},
		getStarkenAgenciasResultLocal(response) { },
		getStarkenCiudadesResultLocal(response) {
			this.getStarkenAgencias()
		},
		initModuleLocal() {
			this.setShippingRequestComponentInit()
		},
		obtenerCorreosChileComunasResultLocal(response) {
			this.obtenerCorreosChileSucursales()
		},
		obtenerCorreosChileSucursalesResultLocal(response) { },
		setShippingRequestComponentInit() {
			this.typeStatusId = 3
			this.getAllTrackingsShippingRequest()
			this.getAllComunas()
			this.getAllTransports()
			/*this.getAllComunas()
			this.getAllTypeLegalDocuments()
			this.getAllStatus()*/
		},
		showShippingRequestLocal() {
			this.idLocal = this.id
			this.idLocal = 55175
			if (this.idLocal > 0) {
				this.clearShippingRequestLocal()
				this.showShippingRequest(this.idLocal)
			}
		},
		showShippingRequestResultLocal(response) {
			if (response.data.success == true) {
				this.objectShippingRequest.total_price = parseInt(this.objectShippingRequest.total_price)
				this.trackingsShippingIDSelected = this.determineStatusTracking(this.objectShippingRequest.status_id)
				if (this.objectShippingRequest.recipient_data != null) {
					this.objectShippingRequest.recipient_data.paid_shipping = (this.objectShippingRequest.recipient_data.paid_shipping == 1)
				}
				this.$emit('shippingRequestFoundResult', response.data.data)
			}
		},
		selectComunaByStrLocal(str) {
			console.log(this.selectComunaByStr(str, true))
		}
	},
	mounted() {
		this.initModule(this.$options.name)
	},
}
</script>